import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import PropTypes from "prop-types";

class LoadComponentBasedOnVisibility extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isComponentShown: false,
        };
    }

    componentVisibilityCheckHandle = (isVisible) => {
        const {isComponentShown} = this.state;
        const {onChange} = this.props;
        if (!isComponentShown && isVisible) {
            this.setState({isComponentShown: true});
            if (onChange) onChange(isVisible);
        }
    };

    renderComponentOrLoader = () => {
        const {isComponentShown} = this.state;
        /* eslint-disable no-unused-vars */
        const {
            ContentLoader,
            isLoaderVisible,
            debug,
            onChange,
            WrappedComponent,
            ...rest
        } = this.props;
        /* eslint-enable */
        if ((isComponentShown && !isLoaderVisible) || ContentLoader === false) {
            return <WrappedComponent isComponentShown={isComponentShown} {...rest} />;
        } else {
            return ContentLoader;
        }
    };

    render() {
        const {isComponentShown} = this.state;
        return (
            <VisibilitySensor
                onChange={this.componentVisibilityCheckHandle}
                offset={{top: 1}}
                partialVisibility
                active={!isComponentShown}
                intervalCheck={false}
                scrollCheck={true}
                scrollThrottle={100}
                delayedCall={true}
            >
                {this.renderComponentOrLoader()}
            </VisibilitySensor>
        );
    }
}
LoadComponentBasedOnVisibility.propTypes = {
    ContentLoader: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
    onChange: PropTypes.func,
    isLoaderVisible: PropTypes.bool,
    WrappedComponent: PropTypes.elementType.isRequired,
    debug: PropTypes.bool,
};

LoadComponentBasedOnVisibility.defaultProps = {
    ContentLoader: false,
    isLoaderVisible: false,
    debug: false,
};
export default LoadComponentBasedOnVisibility;
